<template>
  <div class="p-6 w-full h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Members</p>
      <div class="flex flex-row items-center justify-between space-x-2">
        <div class="relative group">
          <input type="text" v-model="searchText" class="bg-light-gray px-4 py-3 rounded-full font-sans"
                 placeholder="Search for members" v-on:keyup.enter="handleSearch"/>
          <MagnifyingGlassIcon class="absolute bottom-3 right-3 w-6 h-6 text-gray"/>
        </div>
        <!-- action button -->
        <div>
          <input ref="excelFileImport" class="hidden" type="file"
                 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" name="excelFile"
                 @change="onFileChange($event)" @click="onSameFile($event)"/>
          <BaseRoundedButton :disabled="isImportDisable" @click="handleFileImport">
            <p class="font-sans">Import</p>
          </BaseRoundedButton>
        </div>
        <BaseRoundedButton :disabled="isExportDisable" @click="handleExport">
          <p class="font-sans">Export as Excel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleCreateSlideOver">
          <p class="font-sans">Create Member</p>
        </BaseRoundedButton>
      </div>
    </div>
    <!-- filters -->
    <div class="flex flex-row space-x-2 items-center justify-end py-1">
      <!-- filter by subscription -->
      <div class="relative cursor-pointer">
        <div>
          <listbox v-model="subFilter">
            <ListboxButton>
              <div class="flex flex-row space-x-2 items-center">
                <p class="text-gray">Subscription:</p>
                <p v-if="subFilter.name" class="text-blue">
                  {{ subFilter.name ? subFilter.name : 'N/A' }}
                </p>
                <p v-else class="text-blue">None</p>
                <ChevronDownIcon class="w-4 h-4 text-gray"/>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                              absolute
                              py-2
                              w-full
                              bg-white
                              rounded-lg
                              shadow-md
                              border border-light-gray
                            ">
                <ListboxOption value="" @click="handleSearch" class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  None
                </ListboxOption>
                <ListboxOption v-for="option in subFilterOption" :key="option.key" :value="option" @click="handleSearch"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option.name ? option.name : 'N/A' }}

                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
      </div>
      <!-- filter by payment status -->
      <div class="relative cursor-pointer">
        <div>
          <listbox v-model="paymentStatusFilter">
            <ListboxButton>
              <div class="flex flex-row space-x-2 items-center">
                <p class="text-gray">Payment Status:</p>
                <p class="text-blue">
                  {{ paymentStatusFilter.name ? paymentStatusFilter.name : 'N/A' }}

                </p>
                <ChevronDownIcon class="w-4 h-4 text-gray"/>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                              absolute
                              py-2
                              w-full
                              bg-white
                              rounded-lg
                              shadow-md
                              border border-light-gray
                            ">
                <ListboxOption v-for="option in paymentStatusFilterOption" :key="option.key" :value="option"
                               @click="handleSearch" class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option.name ? option.name : 'N/A' }}

                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
      </div>
      <!-- filter by paid status -->
      <div class="relative cursor-pointer">
        <div>
          <listbox v-model="isPaidFilter">
            <ListboxButton>
              <div class="flex flex-row space-x-2 items-center">
                <p class="text-gray">Paid Status:</p>
                <p class="text-blue">
                  {{ isPaidFilter.name ? isPaidFilter.name : 'N/A' }}

                </p>
                <ChevronDownIcon class="w-4 h-4 text-gray"/>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                              absolute
                              py-2
                              w-full
                              bg-white
                              rounded-lg
                              shadow-md
                              border border-light-gray
                            ">
                <ListboxOption v-for="option in isPaidFilterOption" :key="option.key" :value="option"
                               @click="handleSearch" class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option.name ? option.name : 'N/A' }}

                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
      </div>
      <!-- filter by status -->
      <div class="relative cursor-pointer">
        <div>
          <listbox v-model="statusFilter">
            <ListboxButton>
              <div class="flex flex-row space-x-2 items-center">
                <p class="text-gray">Status:</p>
                <p class="text-blue">
                  {{ statusFilter.name ? statusFilter.name : 'N/A' }}
                </p>
                <ChevronDownIcon class="w-4 h-4 text-gray"/>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                              absolute
                              py-2
                              w-full
                              bg-white
                              rounded-lg
                              shadow-md
                              border border-light-gray
                            ">
                <ListboxOption v-for="option in statusFilterOption" :key="option.key" :value="option"
                               @click="handleSearch" class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option.name ? option.name : 'N/A' }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
      </div>
      <!-- more options -->
      <div class="relative cursor-pointer">
        <div>
          <listbox v-model="statusFilter">
            <ListboxButton>
              <div class="flex flex-row space-x-2 items-center px-4 py-3 rounded-full group">
                <Squares2X2Icon class="w-6 h-6 text-gray group-hover:text-blue"/>
                <p class="text-gray group-hover:text-blue">More Options</p>
                <ChevronDownIcon class="w-4 h-4 text-gray group-hover:text-blue"/>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class=" absolute py-2  w-full bg-white rounded-lg shadow-md border border-light-gray">
                <ListboxOption @click="handleshowSendMessage"
                               class="group hover:bg-light-gray px-4 py-2 font-sans font-md">
                  <p class="group-hover:text-blue">Send Message</p>
                </ListboxOption>
                <ListboxOption @click="handleMarkInactive"
                               class="group hover:bg-light-gray px-4 py-2 font-sans font-md">
                  <p class="group-hover:text-blue">Mark Inactive</p>
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
      </div>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b-2 border-light-gray">
        <tr class="text-left text-gray text-md">
          <th class="py-2 font-normal">Profile</th>
          <th class="p-2 font-normal">Name</th>
          <th class="p-2 font-normal">Phone</th>
          <th class="p-2 font-normal">Category</th>
          <th class="p-2 font-normal">Sector</th>
          <th class="p-2 font-normal text-center">Subscription</th>
          <!--          <th class="p-2 font-normal">Created at</th>-->
          <!--          <th class="p-2 font-normal">Updated at</th>-->
          <th class="p-2 font-normal">Payment</th>
          <th class="py-2 font-normal text-center">Payment Status</th>
          <th class="py-2 font-normal text-center">Status</th>
          <th class="py-2 font-normal text-center">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="member in members" :key="member.id" class="text-lg">
          <td>
            <img class="rounded-full w-14 h-14 object-cover my-2" :src="member.profile" alt=""/>
          </td>
          <td class="px-2">{{ member.first_name }} {{ member.last_name }}</td>
          <td class="px-2">{{ member.phone_number }}</td>
          <td class="text-center px-2">
            <p v-if="member.membership_category">{{ member.membership_category }}</p>
          </td>
          <td class="text-center px-2">
            <p v-if="member.membership_sector">{{ member.membership_sector }}</p>
          </td>
          <td class="px-2">
            <div class="flex justify-center">
              <p v-if="member.latest_subscription" class="text-blue text-center">
                {{
                  member.latest_subscription.subscription.name ? member.latest_subscription.subscription.name : 'N/A'
                }}
              </p>
            </div>
          </td>
          <!--          <td class="px-2">{{ moment(member.created_at).format("DD-MM-YY") }}</td>-->
          <!--          <td class="px-2">-->
          <!--            <p>{{ moment(member.updated_at).format("DD-MM-YY") }}</p>-->
          <!--          </td>-->
          <td class="px-2">
            <div @click="handleViewReciept(member)" class="
                            flex
                            items-center
                            space-x-2
                            select-none
                            cursor-pointer
                            group
                          ">
              <EyeIcon class="w-6 h-6 text-blue"/>
              <p class="text-blue">view</p>
            </div>
          </td>
          <td>
            <div class="flex justify-center">
              <div v-if="member.latest_subscription" class="flex justify-center">
                <div v-if="member.latest_subscription.status == '-1'"
                     class="px-4 py-1 bg-light-red text-red rounded-full w-max">
                  <p>Rejected</p>
                </div>
                <div v-if="member.latest_subscription.status == '0'"
                     class="px-4 py-1 bg-light-gray text-gray rounded-full w-max">
                  <p>Pending</p>
                </div>
                <div v-if="member.latest_subscription.status == '1'"
                     class="px-4 py-1 bg-light-blue text-blue rounded-full w-max">
                  <p>Accept</p>
                </div>
              </div>
            </div>
          </td>
          <!-- member status -->
          <td>
            <div class="flex justify-center">
              <div v-if="member.status == '0'" class="px-4 py-1 bg-light-red text-red rounded-full w-max">
                <p>Inactive</p>
              </div>
              <div v-if="member.status == '2'" class="px-4 py-1 bg-light-blue text-blue rounded-full w-max">
                <p>Active</p>
              </div>
            </div>
          </td>
          <td>
            <div class="flex justify-center relative">
              <Menu>
                <MenuButton>
                  <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer"/>
                </MenuButton>
                <MenuItems class="
                                p-1
                                space-y-1
                                absolute
                                top-8
                                right-8
                                z-50
                                bg-white
                                border border-light-gray
                                shadow-md
                                rounded-lg
                                w-12/12
                              ">
                  <MenuItem @click="handleUpdatePayStatus(member.latest_subscription.id, '1')"
                            v-if="member.latest_subscription && member.latest_subscription.status == '0'"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <ReceiptRefundIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">Confirm Payment</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleUpdatePayStatus(member.latest_subscription.id, '-1')"
                            v-if="member.latest_subscription && member.latest_subscription.status == '0'"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <ReceiptRefundIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">Reject Payment</p>
                    </div>
                  </MenuItem>
                  <MenuItem class="
                                  hover:bg-light-blue
                                  m-1
                                  rounded-md
                                  cursor-pointer
                                  w-max
                                " @click="handleViewSubscription(member.id)">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <ReceiptRefundIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">View Subscription History</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleUpdateSub(member)" v-if="member.status == '2'"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <CreditCardIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">Update Subscription</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleViewSlideOver(member)"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <EyeIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">View Member Detail</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleEdit(member)" class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <PencilIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">Edit Member Detail</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleResetPass(member.id)"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2">
                      <KeyIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">Reset Password</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleDeactivate(member.id)" v-if="member.status == '0'"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <UserPlusIcon class="text-blue w-5 h-5 mr-4"/>
                      <p class="text-blue">Reactivate this account</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleDeactivate(member.id)" v-if="member.status == '2'"
                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <XCircleIcon class="text-red w-5 h-5 mr-4"/>
                      <p class="text-red">Deactive this account</p>
                    </div>
                  </MenuItem>
                  <MenuItem @click="handleDelete(member.id)" class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <TrashIcon class="text-red w-5 h-5 mr-4"/>
                      <p class="text-red">Delete</p>
                    </div>
                  </MenuItem>
                </MenuItems>
              </Menu>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- loading animation -->
    <div class="min-h-full flex flex-col space-y-4 items-center justify-center" v-if="isLoading">
      <div class="animate-ping w-12 h-12 bg-light-gray rounded-full"></div>
      <p class="text-gray text-lg font-sans font-light">Loading data</p>
    </div>
    <!-- no data icon -->
    <div class="min-h-full flex items-center justify-center" v-if="!members.length && !isLoading">
      <div class="flex flex-col">
        <div class="flex justify-center">
          <InboxIcon class="text-gray w-12 h-12 md:w-24 md:h-24"/>
        </div>
        <p class="text-gray text-2xl font-sans font-light">No data found!</p>
      </div>
    </div>
    <div class="mt-auto flex justify-between">
      <p class="text-gray text-lg font-sans font-light">Total: {{ membersMeta.total }}</p>
      <BasePagination :pageCount="membersMeta.last_page" @navigate-to-page="handlePagination($event)"/>
    </div>
  </div>

  <!-- view payment reciept side bar -->
  <SideBar v-show="viewRecSlideOver" @close-modal="handleCloseViewReciept">
    <div class="w-full flex flex-col content-between">
      <h1 class="text-blue text-2xl">Payment</h1>
      <div v-if="tempBankData.bank_name && temPaymentData">
        <div class="bg-light-gray p-4 my-4 rounded-lg space-y-2">
          <p class="text-gray">Payment method</p>
          <p class="text-blue text-xl">
            {{ tempBankData.bank_name }}
          </p>
        </div>
        <div>
          <img class="rounded-md" :src="temPaymentData.attachment_payment_file" alt=""/>
        </div>
      </div>
      <div v-else>
        <p class="text-gray text-base">No payment attach</p>
      </div>
      <div class="flex flex-col space-y-4">
        <div class="flex flex-row space-x-2">
          <p class="text-gray">Paid Status:</p>
          <p class="text-blue">
            {{ tempBankData.status == 1 ? 'Paid' : 'Pending' }}
          </p>
        </div>
        <div class="flex flex-row space-x-2">
          <p class="text-gray">Paid Date:</p>
          <p class="text-blue">
            {{ moment(temPaymentData.payment_date).format("DD-MM-YYYY") }}
          </p>
        </div>
      </div>
    </div>
  </SideBar>
  <!-- reset pass slide over -->
  <SideBar v-show="resetPassSlideOver" @close-modal="handleResetPass('')">
    <div class="w-full flex flex-col content-between">
      <h1 class="text-blue text-2xl">Reset Password</h1>
      <div class="py-4">
        <base-text-input v-model="pass" name="pass" isAutoComplete="off" label="New Password"/>
      </div>
      <!-- action button -->
      <div class="
                    flex flex-row
                    items-center
                    justify-between
                    space-x-4
                    mt-auto
                    mb-12
                  ">
        <BaseRoundedButton @click="handleResetPass('')" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleUpdatePass" class="w-4/6">
          <p>Reset Password</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- view detail Slide over -->
  <!-- view detail Slide over -->
  <SideBar v-show="viewSlideOver" @close-modal="handleViewSlideOver('')">
    <div class="w-full h-full flex flex-col content-between">
      <h1 class="text-blue text-2xl">Member Detail</h1>
      <div class="flex flex-col space-y-4 py-8">
        <!-- profile image -->
        <div class="flex justify-center">
          <img v-if="tempData.profile" :src="tempData.profile" class="w-2/4 rounded-full square_img object-cover" alt=""/>
          <img v-else :src="defaultImage" class="w-2/4 rounded-full square_img object-cover" alt=""/>
        </div>

        <!-- first_name and last name -->
        <div class="flex flex-row mb-2 space-x-2">
          <div class="flex flex-col w-1/2">
            <p class="text-gray font-light mb-2">First Name</p>
            <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
              {{ tempData.first_name }}
            </p>
          </div>
          <div class="flex flex-col w-1/2">
            <p class="text-gray font-light mb-2">Last Name</p>
            <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
              {{ tempData.last_name }}
            </p>
          </div>
        </div>

        <!-- gender and title -->
        <div class="flex flex-row mb-2 space-x-2">
          <div class="flex flex-col w-1/2">
            <p class="text-gray font-light mb-2">Gender</p>
            <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
              <!-- Convert "0", "1", "2" to text -->
              <span v-if="tempData.gender == 0">Male</span>
              <span v-else-if="tempData.gender == 1">Female</span>
              <span v-else-if="tempData.gender == 2">Other</span>
              <span v-else>N/A</span>
            </p>
          </div>
          <div class="flex flex-col w-1/2">
            <p class="text-gray font-light mb-2">Title</p>
            <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
              {{ tempData.title }}
            </p>
          </div>
        </div>

        <!-- dob -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Date of Birth</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ moment(tempData.dob).format("MMM DD, YYYY") }}
          </p>
        </div>

        <!-- citizenship -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Citizenship</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.citizenship }}
          </p>
        </div>

        <!-- phone number -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Phone Number</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.phone_number }}
          </p>
        </div>

        <!-- business phone number -->
        <div v-if="tempData.business_phone" class="flex flex-col">
          <p class="text-gray font-light mb-2">Business Phone</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.business_phone }}
          </p>
        </div>

        <!-- email -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Email</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.email }}
          </p>
        </div>

        <!-- business email -->
        <div v-if="tempData.business_email" class="flex flex-col">
          <p class="text-gray font-light mb-2">Business Email</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.business_email }}
          </p>
        </div>

        <!-- home address -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Home Address</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.home_address }}
          </p>
        </div>

        <!-- name_of_organization_workplace -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">
            Name of Organization/Workplace
          </p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.name_of_organization_workplace }}
          </p>
        </div>

        <!-- job title -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Job Title</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.job_title }}
          </p>
        </div>

        <!-- other job -->
        <div v-if="tempData.other_job" class="flex flex-col">
          <p class="text-gray font-light mb-2">Other Job</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.other_job }}
          </p>
        </div>

        <!-- country_of_university_attended -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Country of University Attended</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.country_of_university_attended }}
          </p>
        </div>

        <!-- name_of_university_attended -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Name of University Attended</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.name_of_university_attended }}
          </p>
        </div>

        <!-- highest_qualification -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Highest Qualification</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.highest_qualification }}
          </p>
        </div>

        <!-- major -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Major</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.major }}
          </p>
        </div>

        <!-- date_of_commencement -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Date of Commencement</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ moment(tempData.date_of_commencement).format("DD MMMM YYYY") }}
          </p>
        </div>

        <!-- date_of_completion -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Date of Completion</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ moment(tempData.date_of_completion).format("DD MMMM YYYY") }}
          </p>
        </div>

        <!-- funding_scheme -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Funding Scheme</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.funding_scheme }}
          </p>
        </div>

        <!-- scholarship_name -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Scholarship Name</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.scholarship_name }}
          </p>
        </div>

        <!-- membership_category -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Member Category</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.membership_category }}
          </p>
        </div>

        <!-- membership_sector -->
        <div v-if="tempData.membership_sector" class="flex flex-col">
          <p class="text-gray font-light mb-2">Membership Sector</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.membership_sector }}
          </p>
        </div>

        <!-- membership status (status=0 => Inactive, 2 => Active) -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Membership Status</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            <span v-if="tempData.status == 2">Active</span>
            <span v-else-if="tempData.status == 0">Inactive</span>
            <span v-else>N/A</span>
          </p>
        </div>

        <!-- subscription info -->
        <div v-if="tempData.latest_subscription" class="flex flex-col">
          <p class="text-gray font-light mb-2">Current Subscription</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.latest_subscription.subscription.name }}
          </p>
        </div>

        <!-- Public info to membership list -->
        <div class="flex flex-col">
          <p class="text-gray font-light mb-2">Public Member?</p>
          <p class="text-lg font-sans p-2 bg-light-gray rounded-lg">
            {{ tempData.public_info_to_membership_list ? 'Yes' : 'No' }}
          </p>
        </div>

        <!-- social_medias (array) -->
        <div v-if="tempData.social_medias && tempData.social_medias.length" class="flex flex-col">
          <p class="text-gray font-light mb-2">Social Links</p>
          <div
              v-for="(item, index) in tempData.social_medias"
              :key="index"
              class="text-lg font-sans p-2 bg-light-gray rounded-lg mb-2"
          >
            <!-- Show the platform name and the link -->
            <strong>{{ item.title }}:</strong>
            <a :href="item.url" target="_blank" class="text-blue underline ml-2">
              {{ item.url }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </SideBar>

  <!-- create member side bar -->
  <SideBar v-show="createSideBar" @close-modal="handleCloseSideBar">
    <div class="w-full h-full flex flex-col content-between">
      <div>
        <h1 v-if="!updateFlag" class="text-blue text-2xl">Create New Member</h1>
        <h1 v-else class="text-blue text-2xl">Update Member</h1>
      </div>
      <div class="my-6 space-y-4">
        <!-- profile image -->
        <div @click="handleProfileImport" class="group py-4 cursor-pointer">
          <!-- hiddden image file input field that triger when profile image container clicked -->
          <input ref="profileUploader" class="hidden" type="file" name="profileImage" id="profileImage" accept="image/*"
                 @change="handleFileUpload($event)"/>
          <div class="flex justify-center">
            <img v-if="imageUrl" class="w-1/4 square_img object-cover rounded-full mb-2" :src="imageUrl" alt=""/>
            <img v-else class="w-1/4 square_img object-cover rounded-full mb-2" :src="defaultImage" alt=""/>
          </div>
          <p class="
                        cursor-pointer
                        text-center text-lg
                        font-sans
                        text-blue
                        group-hover:underline
                      ">
            Change profile image
          </p>
        </div>
        <!-- first name and last name -->
        <div class="flex">
          <base-text-input v-model="first_name" name="first_name" label="First Name" class="w-1/2 pr-2"
                           :isRequired="true"/>
          <base-text-input v-model="last_name" name="last_name" label="Last Name" :isRequired="true"
                           class="w-1/2 pl-2"/>
        </div>
        <!-- gender and title -->
        <div class="flex space-x-2">
          <div class="relative w-1/2">
            <listbox v-model="gender">
              <ListboxButton class="w-full">
                <div>
                  <div class="flex">
                    <p class="text-left text-gray mb-2">Gender</p>
                    <p class="text-red">*</p>
                  </div>
                  <div class="
                                flex
                                items-center
                                justify-between
                                w-full
                                px-2
                                py-3
                                rounded-xl
                                border border-dark-gray
                                z-50
                              ">
                    <p v-if="gender == 1">Female</p>
                    <p v-if="gender == 2">Other</p>
                    <p v-if="gender == 0">Male</p>
                    <ChevronDownIcon class="w-4 h-4 text-gray"/>
                  </div>
                </div>
              </ListboxButton>
              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-out"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                <ListboxOptions class="
                              absolute
                              py-2
                              w-full
                              bg-white
                              rounded-lg
                              shadow-md
                              border border-light-gray
                              z-50
                            ">
                  <ListboxOption v-for="(gender, index) in genders" :key="index" :value="index"
                                 class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                    {{ gender }}
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </listbox>
          </div>
          <div class="relative w-1/2">
            <listbox v-model="title">
              <ListboxButton class="w-full">
                <div>
                  <p class="text-left text-gray mb-2">Title</p>
                  <div class="
                                flex
                                items-center
                                justify-between
                                w-full
                                px-2
                                py-3
                                rounded-xl
                                border border-dark-gray
                                z-50
                              ">
                    <p v-if="!title" class="text-left text-gray">
                      Select title
                    </p>
                    <p v-else class="text-blue">{{ title }}</p>
                    <ChevronDownIcon class="w-4 h-4 text-gray"/>
                  </div>
                </div>
              </ListboxButton>
              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-out"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                <ListboxOptions class="
                              absolute
                              py-2
                              w-full
                              bg-white
                              rounded-lg
                              shadow-md
                              border border-light-gray
                              z-50
                            ">
                  <ListboxOption v-for="(title, index) in titles" :key="index" :value="title"
                                 class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                    {{ title }}
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </listbox>
          </div>
        </div>
        <!-- date of birth -->
        <base-text-input v-model="dob" type="date" name="dob" label="Date of Birht"/>
        <!-- citizenship -->
        <div class="relative">
          <listbox v-model="citizenship">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Citizenship</p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!citizenship" class="text-left text-gray">
                    Select citizenship
                  </p>
                  <p v-else class="text-blue">{{ citizenship }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            absolute
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                          ">
                <ListboxOption v-for="(citizenship, index) in citizenships" :key="index" :value="citizenship"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ citizenship }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <!-- phone number -->
        <base-text-input v-model="phoneNumber" name="phoneNumber" label="Phone Number" :isRequired="true"/>
        <!-- buss phone number -->
        <base-text-input v-model="bussPhoneNumber" name="bussPhoneNumber" label="Business Phone (Alternative)"/>
        <!-- email -->
        <base-text-input v-model="email" name="email" label="Email" :isRequired="true"/>
        <!-- buss email -->
        <base-text-input v-model="bussEmail" name="bussEmail" label="Business Email (Alternative)"/>
        <!-- password -->
        <base-text-input v-if="!updateFlag" v-model="pass" name="pass" label="Password" :isRequired="true"/>
        <!-- address -->
        <base-text-input v-model="address" name="address" label="Address"/>
        <!-- work place -->
        <base-text-input v-model="workPlace" name="workPlace" label="Name of Oraganization/Workplace"/>
        <!-- job tile -->
        <base-text-input v-model="jobTitle" name="jobTitle" label="Job Title" :isRequired="true"/>
        <!-- orther Job -->
        <base-text-input v-model="otherJob" name="otherJob" label="Other Job (if any)"/>
        <div>
          <p class="text-gray font-sans font-light text-lg mb-2">
            Social Media
          </p>
        </div>
        <!-- facebook -->
        <base-text-input v-model="social.facebook" name="facebook" label="Facebook"/>
        <!-- orther Job -->
        <base-text-input v-model="social.linkedin" name="linkedin" label="linkedIn"/>
        <div>
          <p class="text-gray font-sans font-light text-lg mb-2">
            Education Background
          </p>
        </div>
        <!-- university country -->
        <base-text-input v-model="countryUniv" name="contryUniv" label="Country of University Attended"/>
        <!-- university name -->
        <base-text-input v-model="UnivName" name="UnivName" label="Name of University Attended"/>
        <!-- Qualification -->
        <div class="relative">
          <listbox v-model="qualification">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Qualification</p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!qualification" class="text-left text-gray">
                    Select qualification
                  </p>
                  <p v-else class="text-blue">{{ qualification }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            absolute
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                          ">
                <ListboxOption v-for="(qualification, index) in qualifications" :key="index" :value="qualification"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ qualification }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <!-- major name -->
        <base-text-input v-model="major" name="major" label="Major"/>
        <!-- date of Commencement -->
        <base-text-input v-model="dateOfCommencement" type="date" name="dateofCommencement"
                         label="Date of Commencement"/>
        <!-- date of complition -->
        <base-text-input v-model="dateOfCompletion" type="date" name="dateOfCompletion" label="Date of Completion"/>
        <!-- Funding -->
        <div class="relative">
          <listbox v-model="fundingScheme">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Funding Scheme</p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!fundingScheme" class="text-left text-gray">
                    Select funding scheme
                  </p>
                  <p v-else class="text-blue">{{ fundingScheme }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            absolute
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                          ">
                <ListboxOption v-for="(fundingScheme, index) in fundingSchemes" :key="index" :value="fundingScheme"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ fundingScheme }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <!-- scholarship name -->
        <base-text-input v-model="scholarName" name="scholarName" label="Scholarship Name" class="pb-5"/>
        <!-- public member -->
        <div class="relative">
          <listbox v-model="publicMember">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Public Member</p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                              z-50
                            ">
                  <p v-if="publicMember == 1" class="text-left text-gray">
                    Yes
                  </p>
                  <p v-if="publicMember == 0" class="text-left text-gray">No</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            absolute
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                            z-50
                          ">
                <ListboxOption v-for="(option, index) in yesNoOptions" :key="index" :value="index"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <div>
          <p class="text-gray font-sans font-light text-lg mb-2">Payment</p>
        </div>
        <!-- Member category -->
        <div class="relative">
          <listbox v-model="membertype">
            <ListboxButton class="w-full">
              <div>
                <div class="flex">
                  <p class="text-left text-gray mb-2">Membership Category</p>
                  <p class="text-red">*</p>
                </div>
                <p class="text-left text-gray mb-2"></p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!membertype" class="text-left text-gray">
                    Select membership category
                  </p>
                  <p v-else class="text-blue">{{ membertype }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            absolute
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                            z-50
                          ">
                <ListboxOption v-for="member in memberTypes" :key="member.id" :value="member.name"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ member.name ? member.name : 'N/A' }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <!-- Working Sector -->
        <div class="relative">
          <listbox v-model="memberSector">
            <ListboxButton class="w-full">
              <div>
                <div class="flex">
                  <p class="text-left text-gray mb-2">Membership Sector</p>
                  <p class="text-red">*</p>
                </div>
                <p class="text-left text-gray mb-2"></p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!memberSector" class="text-left text-gray">
                    Select membership sector
                  </p>
                  <p v-else class="text-blue">{{ memberSector }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            absolute
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                            z-50
                          ">
                <ListboxOption v-for="sector in memberSectors" :key="sector.id" :value="sector.name"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ sector.name ? sector.name : 'N/A' }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <!-- Subscription -->
        <div v-if="!updateFlag" class="relative">
          <listbox v-model="subscription">
            <ListboxButton class="w-full">
              <div>
                <div class="flex">
                  <p class="text-left text-gray mb-2">Subscription</p>
                  <p class="text-red">*</p>
                </div>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!subscription" class="text-left text-gray">
                    Select subscription type
                  </p>
                  <p v-else class="text-left text-gray">
                    {{ subscription.name ? subscription.name : 'N/A' }}
                  </p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions class="
                            py-2
                            w-full
                            bg-white
                            rounded-lg
                            shadow-md
                            border border-light-gray
                            max-h-96
                            overflow-auto
                          ">
                <ListboxOption v-for="option in subFilterOption" :key="option.key" :value="option"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option.name ? option.name : 'N/A' }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <div v-if="!isFirstNameValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">First name is required</p>
        </div>
        <div v-if="!isLastNameValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Last name is required</p>
        </div>
        <div v-if="!isJobTitleValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Job tilte is required</p>
        </div>
        <div v-if="!isPhoneNumberValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Phone number is required</p>
        </div>
        <div v-if="!isEmailValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Email is required</p>
        </div>
        <div v-if="!isPasswordValid && !updateFlag" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Password is required</p>
        </div>
        <div v-if="!isMemberCategoryValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Member Category is required</p>
        </div>
        <div v-if="!isMemberSectorValid" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Working Sector is required</p>
        </div>
        <div v-if="!isSubscriptionValid && !updateFlag" class="flex space-x-2 items-center">
          <ExclamationTriangleIcon class="w-6 h-6 text-red"/>
          <p class="text-red font-light">Subscription is required</p>
        </div>
      </div>
      <div class="
                    flex flex-row
                    items-center
                    justify-between
                    space-x-4
                    mt-auto
                    pb-8
                  ">
        <BaseRoundedButton @click="handleCloseSideBar" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton v-if="!updateFlag" :disabled="!isCreateMemberValid" @click="handleCreate" class="w-4/6">
          <p>Create Member</p>
        </BaseRoundedButton>
        <BaseRoundedButton v-else :disabled="!isUpdateValid" @click="handleUpdateMember" class="w-4/6">
          <p>Save Update</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- update subscription -->
  <SideBar v-show="updateSubFlag" @close-modal="handleCloseSideBar">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <h1 class="text-blue text-2xl">Update Member Subscription</h1>
      <div class="my-4 h-full flex flex-col space-y-4">
        <div class="flex flex-col h-full space-y-4">
          <div class="relative">
            <listbox v-model="subscription">
              <ListboxButton class="w-full">
                <div>
                  <div class="flex">
                    <p class="text-left text-gray mb-2">Subscription</p>
                    <p class="text-red">*</p>
                  </div>
                  <p class="text-left text-gray mb-2"></p>
                  <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                    <p v-if="!subscription" class="text-left text-gray">
                      Select membership category
                    </p>
                    <p v-else class="text-blue">
                      {{ subscription.name ? subscription.name : 'N/A' }}
                    </p>
                    <ChevronDownIcon class="w-4 h-4 text-gray"/>
                  </div>
                </div>
              </ListboxButton>
              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-out"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                <ListboxOptions
                    class=" absolute py-2 w-full bg-white rounded-lg shadow-md border border-light-gray max-h-96 overflow-auto z-50">
                  <ListboxOption v-for="option in subFilterOption" :key="option.key" :value="option"
                                 class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                    {{ option.name ? option.name : 'N/A' }}
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </listbox>
          </div>
          <!-- year -->
          <div class="relative">
            <listbox v-model="year">
              <ListboxButton class="w-full">
                <div>
                  <div class="flex">
                    <p class="text-left text-gray mb-2">For Year</p>
                    <p class="text-red">*</p>
                  </div>
                  <p class="text-left text-gray mb-2"></p>
                  <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                    <p v-if="!year" class="text-left text-gray">
                      Choose year
                    </p>
                    <p v-else class="text-blue">{{ year }}</p>
                    <ChevronDownIcon class="w-4 h-4 text-gray"/>
                  </div>
                </div>
              </ListboxButton>
              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-out"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                <ListboxOptions
                    class=" absolute py-2 w-full bg-white rounded-lg shadow-md border border-light-gray max-h-96 overflow-auto z-50">
                  <ListboxOption v-for="(option, index) in years" :key="index" :value="option"
                                 class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                    {{ option }}
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </listbox>
          </div>
          <!-- payment method -->
          <div class="relative">
            <listbox v-model="paymentMethod">
              <ListboxButton class="w-full">
                <div>
                  <div class="flex">
                    <p class="text-left text-gray mb-2">Payment Method</p>
                    <p class="text-red">*</p>
                  </div>
                  <p class="text-left text-gray mb-2"></p>
                  <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                    <p v-if="!paymentMethod" class="text-left text-gray">
                      Select payment method
                    </p>
                    <p v-else class="text-blue">{{ paymentMethod.bank_name }}</p>
                    <ChevronDownIcon class="w-4 h-4 text-gray"/>
                  </div>
                </div>
              </ListboxButton>
              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-out"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                <ListboxOptions
                    class=" absolute py-2 w-full bg-white rounded-lg shadow-md border border-light-gray max-h-96 overflow-auto z-50">
                  <ListboxOption v-for="option in paymentMethods" :key="option.key" :value="option"
                                 class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                    {{ option.bank_name }}
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </listbox>
          </div>
          <!-- confirm payment -->
          <div class="relative">
            <listbox v-model="payStatus">
              <ListboxButton class="w-full">
                <div>
                  <div class="flex">
                    <p class="text-left text-gray mb-2">Confirm Payment</p>
                    <p class="text-red">*</p>
                  </div>
                  <p class="text-left text-gray mb-2"></p>
                  <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                    <p v-if="!payStatus" class="text-left text-gray">
                      Confirm Payment
                    </p>
                    <p v-else class="text-blue">
                      {{ payStatus.name ? payStatus.name : 'N/A' }}
                    </p>
                    <ChevronDownIcon class="w-4 h-4 text-gray"/>
                  </div>
                </div>
              </ListboxButton>
              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-out"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                <ListboxOptions
                    class=" absolute py-2 w-full bg-white rounded-lg shadow-md border border-light-gray max-h-96 overflow-auto z-50">
                  <ListboxOption v-for="(option, index) in isPaid" :key="index" :value="option"
                                 class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                    {{ option.name ? option.name : 'N/A' }}
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </listbox>
          </div>
          <!-- payment date -->
          <base-text-input v-model="paymentDate" type="date" name="paymentDate" label="Payment Date"
                           class="w-full px-2 py-3 rounded-xl border border-dark-gray"/>
          <!-- reciept image -->
          <div @click="handleProfileImport" class="group py-4 cursor-pointer">
            <p class="text-gray mb-4">Payment Receipt</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input ref="profileUploader" class="hidden" type="file" name="profileImage" id="profileImage"
                   accept="image/*"
                   @change="handleFileUpload($event)"/>
            <div class="flex justify-center">
              <img v-if="imageFile" class="w-full rect_img object-cover rounded-xl mb-2" :src="imageUrl" alt=""/>
              <img v-else class="w-full rect_img object-cover rounded-xl mb-2"
                   src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg" alt=""/>
            </div>
            <p class="
                        cursor-pointer
                        text-center text-base
                        font-sans
                        text-blue
                        group-hover:underline
                      ">
              Change Receipt Image
            </p>
          </div>

        </div>
      </div>
      <div class=" flex flex-row items-center justify-between space-x-4 mt-auto mb-4 ">
        <BaseRoundedButton @click="handleCloseSideBar" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleSaveUpdate" class="w-4/6">
          <p>Save Update</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <BaseModal :showModal="showConfirmDelete" @closeModal="handleCloseModal">
    <template #header>
      <p class="text-lg font-medium">Delete this account?</p>
    </template>
    <template #body>
      <p class="text-base text-gray">Are you sure you want to delete this account? This action cannot be undone.</p>
    </template>
    <template #footer>
      <div class="flex flex-row items-center justify-end space-x-2 mt-4">
        <BaseRoundedButton @click="handleCloseModal" class="bg-dark-gray w-min">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton :isRed="true" @click="handleDeleteUser" class="bg-dark-blue w-full">
          <p>Delete</p>
        </BaseRoundedButton>
      </div>
    </template>
  </BaseModal>
  <!-- Mark Inactive side bar -->
  <SideBar v-show="markInactiveSideBar" @close-modal="handleCloseMarkInactive">
    <div class="w-full h-full flex flex-col content-between">
      <h1 class="text-blue text-2xl">Mark Inactive for Memember</h1>
      <p class="text-gray font-light">Set members status to inactive status by selected year</p>
      <div class="my-4 flex flex-col space-y-4">
        <!-- year -->
        <div class="relative">
          <listbox v-model="year">
            <ListboxButton class="w-full">
              <div>
                <div class="flex">
                  <p class="text-left text-gray mb-2">Select Year</p>
                  <p class="text-red">*</p>
                </div>
                <p class="text-left text-gray mb-2"></p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!year" class="text-left text-gray">
                    Choose year
                  </p>
                  <p v-else class="text-blue">{{ year }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions
                  class=" absolute py-2 w-full bg-white rounded-lg shadow-md border border-light-gray max-h-96 overflow-auto z-50">
                <ListboxOption v-for="(option, index) in inActiveYears" :key="index" :value="option"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
      </div>
      <div class=" flex flex-row items-center justify-between space-x-4 mt-auto mb-4 ">
        <BaseRoundedButton @click="handleCloseMarkInactive" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleShowConfirmInactive" class="w-4/6">
          <p>Mark Inactive</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- confirm inactive  -->
  <BaseModal :showModal="confirmInactive" @closeModal="handleCloseModal">
    <template #header>
      <p class="text-lg font-medium">Set members with subscription of {{ this.year }} to inactive</p>
    </template>
    <template #body>
      <p class="text-base text-gray">Are you sure you want to set all member to inactive? This action cannot be undone.
      </p>
    </template>
    <template #footer>
      <div class="flex flex-row items-center justify-end space-x-2 mt-4">
        <BaseRoundedButton @click="handleCloseModal" class="bg-dark-gray w-min">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleMarkInactiveUser" class="bg-dark-blue w-full">
          <p>Confrim</p>
        </BaseRoundedButton>
      </div>
    </template>
  </BaseModal>
  <!-- send remind message -->
  <SideBar v-show="showSendRemindMsg" @close-modal="handleCloseSendRemindMsg">
    <div class="w-full h-full flex flex-col content-between">
      <h1 class="text-blue text-2xl">Send Message to Member</h1>
      <p class="text-gray font-light">Send message or reminder to member by year</p>
      <div class="my-4 h-full flex flex-col space-y-4">
        <base-text-input v-model="msgTitle" name="title" label="Title" :isRequired="true"/>
        <!-- year -->
        <div class="relative">
          <listbox v-model="year">
            <ListboxButton class="w-full">
              <div>
                <div class="flex">
                  <p class="text-left text-gray mb-2">Select Year</p>
                  <p class="text-red">*</p>
                </div>
                <p class="text-left text-gray mb-2"></p>
                <div class="
                              flex
                              items-center
                              justify-between
                              w-full
                              px-2
                              py-3
                              rounded-xl
                              border border-dark-gray
                            ">
                  <p v-if="!year" class="text-left text-gray">
                    Choose year
                  </p>
                  <p v-else class="text-blue">{{ year }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray"/>
                </div>
              </div>
            </ListboxButton>
            <transition enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-out"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
              <ListboxOptions
                  class=" absolute py-2 w-full bg-white rounded-lg shadow-md border border-light-gray max-h-96 overflow-auto z-50">
                <ListboxOption v-for="(option, index) in inActiveYears" :key="index" :value="option"
                               class="hover:bg-light-gray px-4 py-2 font-sans font-md">
                  {{ option }}
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </listbox>
        </div>
        <div class="flex flex-col h-full space-y-2">
          <p class="text-gray">Content</p>
          <textarea class="max-h-full h-3/6 min-h-24 px-2 py-3 border border-gray rounded-lg" name="content"
                    v-model="content"></textarea>
        </div>
      </div>
      <div class=" flex flex-row items-center justify-between space-x-4 mt-auto mb-4 ">
        <BaseRoundedButton @click="handleCloseSendRemindMsg" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleSendMessage" class="w-4/6">
          <p>Send</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>

<script>
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import BaseModal from "../components/BaseModal.vue";
import {
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import {
  MagnifyingGlassIcon,
  EllipsisVerticalIcon,
  EyeIcon,
  ReceiptRefundIcon,
  KeyIcon,
  TrashIcon,
  UserPlusIcon,
  ChevronDownIcon,
  PencilIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  CreditCardIcon,
  Squares2X2Icon,
} from "@heroicons/vue/24/outline";
import {InboxIcon} from "@heroicons/vue/24/solid";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import userService from "../Services/user.service";
import BasePagination from "../components/BasePagination.vue";
import {useToast} from "vue-toastification";
import { readSheet } from "read-excel-file/browser";
import writeExcelFile from "write-excel-file/browser";
import moment from "moment";

const map = {
  "First Name": "first_name",
  "Last Name": "last_name",
  "Phone Number": "phone_number",
  "Date of Birth": "dob",
  Gender: "gender",
  Email: "email",
  Title: "title",
  "Business Phone": "business_phone",
  "Business Email": "business_email",
  "Home Address": "home_address",
  Citizenship: "citizenship",
  "Name of Organization/Workplace": "name_of_organization_workplace",
  "Job Title": "job_title",
  "Other Job": "other_job",
  "Country of University Attended": "country_of_university_attended",
  "Name of University Attended": "name_of_university_attended",
  "Highest Qualification": "highest_qualification",
  Major: "major",
  "Date of Commencement": "date_of_commencement",
  "Date of Completion": "date_of_completion",
  "Funding Scheme": "funding_scheme",
  "Scholarship Name": "scholarship_name",
  "Publicc Member": "public_info_to_membership_list",
  "Member Category": "membership_category",
  "Sector": "membership_sector",
  Subscription: "subscription_id",
};

const memberImportSchema = Object.fromEntries(
    Object.entries(map).map(([column, property]) => [property, {column}])
);

const getSheetData = (rows) => {
  if (!rows.length) return [[]];

  const headers = Object.keys(rows[0]);

  return [
    headers.map((header) => ({value: header, fontWeight: "bold"})),
    ...rows.map((row) =>
        headers.map((header) => ({
          value: row[header] === undefined ? null : row[header],
        }))
    ),
  ];
};

const getSheetColumns = (columns) => columns.map(({wch}) => ({width: wch}));

export default {
  components: {
    BaseRoundedButton,
    MagnifyingGlassIcon,
    EllipsisVerticalIcon,
    EyeIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    SideBar,
    ReceiptRefundIcon,
    KeyIcon,
    TrashIcon,
    BaseTextInput,
    BasePagination,
    UserPlusIcon,
    ChevronDownIcon,
    InboxIcon,
    PencilIcon,
    ExclamationTriangleIcon,
    XCircleIcon,
    BaseModal,
    CreditCardIcon,
    Squares2X2Icon,
  },
  setup() {
    const toast = useToast();
    return {toast};
  },
  data() {
    return {
      isLoading: true,
      viewRecSlideOver: false,
      viewSlideOver: false,
      resetPassSlideOver: false,
      createSideBar: false,
      updateFlag: false,
      updateSubFlag: false,
      temPaymentData: {},
      tempBankData: {},
      pass: "",
      members: [],
      allMembers: [],
      totalMember: 0,
      membersMeta: [],
      params: new URLSearchParams(),
      tempId: "",
      searchText: "",
      subFilterOption: [],
      subFilter: "",
      statusFilterOption: [
        {kay: "", name: "None"},
        {key: "2", name: "Active"},
        {key: "0", name: "Inactive"},
      ],
      statusFilter: {kay: "", name: "None"},
      paymentStatusFilterOption: [
        {kay: "", name: "None"},
        {key: "1", name: "Accept"},
        {key: "0", name: "Pending"},
        {key: "-1", name: "Reject"},
      ],
      paymentStatusFilter: {kay: "", name: "None"},
      isPaidFilterOption: [
        {
          name: "None",
          value: "",
        },
        {
          name: "Paid",
          value: "1",
        },
        {
          name: "Unpaid",
          value: "0",
        },
      ],
      isPaidFilter:
          {
            name: "None",
            value: "",
          },
      importedMembers: [],
      isImportDisable: false,
      isExportDisable: false,
      genderList: [
        {id: "0", name: "Male"},
        {id: "1", name: "Female"},
        {id: "2", name: "Other"},
      ],
      publicMemberList: [
        {id: "0", name: "False"},
        {id: "1", name: "True"},
      ],
      tempData: [],
      imageUrl: "",
      defaultImage: "https://i0.wp.com/goodguidancestories.org/wp-content/uploads/2020/05/Portrait_Placeholder.png?resize=600%2C600&ssl=1",
      email: "",
      bussEmail: "",
      memberStatus: "",
      imageFile: "",
      paymentImageFile: "",
      first_name: "",
      last_name: "",
      gender: 0,
      title: "",
      dob: "",
      citizenship: "",
      phoneNumber: "",
      bussPhoneNumber: "",
      address: "",
      workPlace: "",
      jobTitle: "",
      otherJob: "",
      countryUniv: "",
      UnivName: "",
      qualification: "",
      major: "",
      dateOfCommencement: "",
      dateOfCompletion: "",
      fundingScheme: "",
      scholarName: "",
      publicMember: 1,
      membertype: "",
      memberSector: "",
      paymentMethod: "",
      paymentRecipt: "",
      social: {
        facebook: "",
        linkedin: "",
      },
      genders: ["Male", "Female", "Other"],
      titles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof"],
      qualifications: ["PhD", "Master", "Bachelor", "Diploma"],
      fundingSchemes: ["Scholarship", "Private Funding"],
      membertypes: ["General Member", "Associate Member"],
      membersectors: ["Government", "Private Sector", "CSO"],
      yesNoOptions: ["No", "Yes"],
      paymentMethods: [],
      subscription: "",
      subscriptions: [],
      citizenships: [
        "Afghan",
        "Albanian",
        "Algerian",
        "American",
        "Andorran",
        "Angolan",
        "Antiguans",
        "Argentinean",
        "Armenian",
        "Australian",
        "Austrian",
        "Azerbaijani",
        "Bahamian",
        "Bahraini",
        "Bangladeshi",
        "Barbadian",
        "Barbudans",
        "Batswana",
        "Belarusian",
        "Belgian",
        "Belizean",
        "Beninese",
        "Bhutanese",
        "Bolivian",
        "Bosnian",
        "Brazilian",
        "British",
        "Bruneian",
        "Bulgarian",
        "Burkinabe",
        "Burmese",
        "Burundian",
        "Cambodian",
        "Cameroonian",
        "Canadian",
        "Cape Verdean",
        "Central African",
        "Chadian",
        "Chilean",
        "Chinese",
        "Colombian",
        "Comoran",
        "Congolese",
        "Costa Rican",
        "Croatian",
        "Cuban",
        "Cypriot",
        "Czech",
        "Danish",
        "Djibouti",
        "Dominican",
        "Dutch",
        "East Timorese",
        "Ecuadorean",
        "Egyptian",
        "Emirian",
        "Equatorial Guinean",
        "Eritrean",
        "Estonian",
        "Ethiopian",
        "Fijian",
        "Filipino",
        "Finnish",
        "French",
        "Gabonese",
        "Gambian",
        "Georgian",
        "German",
        "Ghanaian",
        "Greek",
        "Grenadian",
        "Guatemalan",
        "Guinea-Bissauan",
        "Guinean",
        "Guyanese",
        "Haitian",
        "Herzegovinian",
        "Honduran",
        "Hungarian",
        "I-Kiribati",
        "Icelander",
        "Indian",
        "Indonesian",
        "Iranian",
        "Iraqi",
        "Irish",
        "Israeli",
        "Italian",
        "Ivorian",
        "Jamaican",
        "Japanese",
        "Jordanian",
        "Kazakhstani",
        "Kenyan",
        "Kittian and Nevisian",
        "Kuwaiti",
        "Kyrgyz",
        "Laotian",
        "Latvian",
        "Lebanese",
        "Liberian",
        "Libyan",
        "Liechtensteiner",
        "Lithuanian",
        "Luxembourger",
        "Macedonian",
        "Malagasy",
        "Malawian",
        "Malaysian",
        "Maldivan",
        "Malian",
        "Maltese",
        "Marshallese",
        "Mauritanian",
        "Mauritian",
        "Mexican",
        "Micronesian",
        "Moldovan",
        "Monacan",
        "Mongolian",
        "Moroccan",
        "Mosotho",
        "Motswana",
        "Mozambican",
        "Namibian",
        "Nauruan",
        "Nepalese",
        "New Zealander",
        "Nicaraguan",
        "Nigerian",
        "Nigerien",
        "North Korean",
        "Northern Irish",
        "Norwegian",
        "Omani",
        "Pakistani",
        "Palauan",
        "Panamanian",
        "Papua New Guinean",
        "Paraguayan",
        "Peruvian",
        "Polish",
        "Portuguese",
        "Qatari",
        "Romanian",
        "Russian",
        "Rwandan",
        "Saint Lucian",
        "Salvadoran",
        "Samoan",
        "San Marinese",
        "Sao Tomean",
        "Saudi",
        "Scottish",
        "Senegalese",
        "Serbian",
        "Seychellois",
        "Sierra Leonean",
        "Singaporean",
        "Slovakian",
        "Slovenian",
        "Solomon Islander",
        "Somali",
        "South African",
        "South Korean",
        "Spanish",
        "Sri Lankan",
        "Sudanese",
        "Surinamer",
        "Swazi",
        "Swedish",
        "Swiss",
        "Syrian",
        "Taiwanese",
        "Tajik",
        "Tanzanian",
        "Thai",
        "Togolese",
        "Tongan",
        "Trinidadian/Tobagonian",
        "Tunisian",
        "Turkish",
        "Tuvaluan",
        "Ugandan",
        "Ukrainian",
        "Uruguayan",
        "Uzbekistani",
        "Venezuelan",
        "Vietnamese",
        "Welsh",
        "Yemenite",
        "Zambian",
        "Zimbabwean",
      ],
      memberTypes: [],
      memberSectors: [],
      errorMsg: "",
      showConfirmDelete: false,
      year: new Date().getFullYear(),
      years: [
        new Date().getFullYear(),
        new Date().getFullYear() + 1,
      ],
      isPaid: [
        {
          name: "Paid",
          value: 1,
        },
        {
          name: "Unpaid",
          value: 0,
        },
      ],
      payStatus: "",
      paymentDate: "",
      markInactiveSideBar: false,
      confirmInactive: false,
      inActiveYears: [
        ...Array.from(
            {length: 10},
            (v, k) => new Date().getFullYear() + k - 10
        ),
        ...Array.from({length: 10}, (v, k) => new Date().getFullYear() + k),
      ],
      showSendRemindMsg: false,
      msgTitle: "",
      content: "",
    };
  },
  methods: {
    getMember() {
      if (this.$route.query.status_id == 0) {
        this.params.set("whereIn", "0");
      } else if (this.$route.query.status_id == 2) {
        this.params.set("whereIn", "2");
      } else {
        this.params.set("whereIn", "0,2");
      }


      userService.getMembers(this.params).then((response) => {
        this.isLoading = false;
        this.members = response.data.data;
        this.totalMember = response.data.meta.total;
        this.membersMeta = response.data.meta;
      });
    },
    getSubscriptionList() {
      userService.getSubscriptionList().then((response) => {
        this.subFilterOption = response.data.data;
        if (this.$route.query.subscription_id == 1 || this.$route.query.subscription_id == 2) {
          for (var option of this.subFilterOption) {
            if (option.id == this.$route.query.subscription_id) {
              this.subFilter = option;
            }
          }
        }
      });
    },
    getPaymentMethod() {
      userService.getPaymentList().then((response) => {
        this.paymentMethods = response.data.data;
      });
    },
    async handleExport() {
      await this.handleGetAllData(this.membersMeta.last_page + 1);
      this.isExportDisable = false;

      const members = this.allMembers.reduce((reducedMember, member) => {
        reducedMember.push({
          "First Name": member.first_name,
          "Last Name": member.last_name,
          "Phone Number": member.phone_number,
          "Date of Birth": member.dob,
          Gender: member.gender === 0 ? "Male" : "Female",
          Email: member.email,
          Title: member.title,
          "Business Phone": member.business_phone,
          "Business Email": member.business_email,
          "Home Address": member.home_address,
          Citizenship: member.citizenship,
          "Name of Organization/Workplace":
          member.name_of_organization_workplace,
          "Job Title": member.job_title,
          "Other Job": member.other_job,
          "Country of University Attended":
          member.country_of_university_attended,
          "Name of University Attended": member.name_of_university_attended,
          "Highest Qualification": member.highest_qualification,
          Major: member.major,
          "Date of Commencement": member.date_of_commencement,
          "Date of Completion": member.date_of_completion,
          "Funding Scheme": member.funding_scheme,
          "Scholarship Name": member.scholarship_name,
          "Public Member": member.public_info_to_membership_list,
          "Member Category": member.membership_category,
          "Sector": member.membership_sector,
          Subscription: member.latest_subscription.subscription.name,
        });
        return reducedMember;
      }, []);
      const ws1cols = [
        {wch: 15},
        {wch: 15},
        {wch: 20},
        {wch: 20},
        {wch: 10},
        {wch: 30},
        {wch: 10},
        {wch: 20},
        {wch: 30},
        {wch: 40},
        {wch: 15},
        {wch: 30},
        {wch: 15},
        {wch: 15},
        {wch: 30},
        {wch: 30},
        {wch: 20},
        {wch: 15},
        {wch: 20},
        {wch: 20},
        {wch: 20},
        {wch: 20},
        {wch: 15},
        {wch: 20},
        {wch: 20},
      ];

      const subscriptions = this.subFilterOption.reduce(
          (newList, subscription) => {
            newList.push({
              id: subscription.id,
              "Subscription Name": subscription.name,
              Description: subscription.description,
              Price: subscription.price,
            });
            return newList;
          },
          []
      );
      const ws4cols = [{wch: 3}, {wch: 20}, {wch: 20}, {wch: 10}];

      await writeExcelFile([
        {
          data: getSheetData(members),
          sheet: "Members",
          columns: getSheetColumns(ws1cols),
        },
        {
          data: getSheetData(this.genderList),
          sheet: "Gender",
        },
        {
          data: getSheetData(this.publicMemberList),
          sheet: "Public Member",
        },
        {
          data: getSheetData(subscriptions),
          sheet: "Subscriptions",
          columns: getSheetColumns(ws4cols),
        },
      ]).toFile("AAA-C Members.xlsx");
    },
    // get all member data on export function call
    async handleGetAllData(all_page) {
      this.isExportDisable = true;
      this.$Progress.start();
      this.toast.info("Generating Excel File ...");
      for (let page = 1; page <= all_page; page++) {
        this.params.set("page", page);
        await userService.getMembers(this.params).then((response) => {
          this.allMembers = this.allMembers.concat(response.data.data);
        });
      }
      this.params.delete("page");
      this.$Progress.finish();
    },
    handleViewReciept(data) {
      this.viewRecSlideOver = true;
      this.temPaymentData = data.latest_subscription || {};
      this.tempBankData = data.latest_subscription.payment || {};
    },
    handleCloseViewReciept() {
      this.viewRecSlideOver = false;
      this.temPaymentData = {};
      this.tempBankData = {};
    },
    handleResetPass(valueId) {
      this.resetPassSlideOver = !this.resetPassSlideOver;
      this.tempId = valueId;
    },
    handleDeactivate(id) {
      this.$Progress.start();
      userService
          .delDeActivate(id)
          .then(() => {
            this.$Progress.finish();
            this.getMember();
            this.toast.success("Udpate account status successful.");
          })
          .catch(() => {
            this.$Progress.fail();
            this.toast.error("Something went wrong! could not update status!");
          });
    },
    handleUpdateStatus(memberId, statusCode) {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("user_id", memberId);
      formData.append("status", statusCode);
      userService
          .storeUpdateStatus(formData)
          .then(() => {
            this.$Progress.finish();
            this.getMember();
            this.toast.success("Account status update success");
          })
          .catch(() => {
            this.$Progress.fail();
            this.toast.error("Something went wrong! Could not update status");
          });
    },
    handleUpdatePayStatus(memberId, statusCode) {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("status", statusCode);

      userService
          .storeUpdatePayStatus(memberId, formData)
          .then(() => {
            this.$Progress.finish();
            this.getMember();
            this.toast.success("Payment status update success.");
          })
          .catch(() => {
            this.$Progress.fail();
            this.toast.error("Something went wrong! Could not update status.");
          });
    },
    handleUpdatePass() {
      this.$Progress.start();
      let formData = new FormData();
      if (this.pass) {
        formData.append("password", this.pass);
      }
      userService
          .storeUpdatePass(this.tempId, formData)
          .then(() => {
            this.$Progress.finish();
            this.pass = "";
            this.tempId = "";
            this.resetPassSlideOver = false;
            this.toast.success("Reset password successful");
          })
          .catch(() => {
            this.$Progress.fail();
            this.toast.error("Something went wrong! Could not reset password");
          });
    },
    handleSearch() {
      this.params.delete("page");
      this.params.set("search", this.searchText);
      if (this.statusFilter.key) {
        this.params.set("status", this.statusFilter.key);
      } else {
        this.params.delete("status");
      }
      if (this.subFilter) {
        this.params.set("subscription_id", this.subFilter.id);
      } else {
        this.params.delete("subscription_id");
      }
      if (this.paymentStatusFilter.key) {
        this.params.set("payment_status", this.paymentStatusFilter.key);
      } else {
        this.params.delete("payment_status");
      }
      this.getMember(this.params.toString());
    },
    handlePagination(value) {
      this.params.set("page", value);
      this.getMember(this.params.toString());
    },
    handleViewSubscription(value) {
      this.$router.push({
        name: "ViewMemberSubscription",
        params: {id: value},
      });
    },
    handleFileImport() {
      this.$refs.excelFileImport.click();
    },
    onSameFile(event) {
      event.target.value = "";
    },
    async onFileChange(event) {
      this.isImportDisable = true;
      let importedFile = event.target.files[0];
      await readSheet(importedFile, {schema: memberImportSchema}).then(({objects = []}) => {
        // here key gender i want convert to 0,1 and subscription_id convert to 1 and 2
        this.importedMembers = objects.map((member) => {
          if (member.gender === "Male") member.gender = 0;
          else if (member.gender === "Female") member.gender = 1;

          if (member.subscription_id === "Annual") member.subscription_id = 1;
          else if (member.subscription_id === "Lifetime") member.subscription_id = 2;

          return member;
        });
      });
      this.importMember();
    },
    async importMember() {
      this.$Progress.start();
      console.log(this.importedMembers);
      // importing multiple members at once
      userService
          .storeImportMembers(this.importedMembers)
          .then(() => {
            this.$Progress.finish();
            this.toast.success("Import Member Successful.");
            this.getMember();
            this.isImportDisable = false;
          })
          .catch((error) => {
            this.$Progress.fail();
            this.toast.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            );
            this.isImportDisable = false;
          });
    },
    handleViewSlideOver(data) {
      this.viewSlideOver = !this.viewSlideOver;
      this.tempData = data;
    },
    handleCreateSlideOver() {
      this.createSideBar = !this.createSideBar;
    },
    handleCloseSideBar() {
      this.createSideBar = false;
      this.updateFlag = false;
      this.updateSubFlag = false;
      this.image = "";
      this.imageUrl = "";
      this.email = "";
      this.bussEmail = "";
      this.memberStatus = "";
      this.imageFile = "";
      this.paymentImageFile = "";
      this.first_name = "";
      this.last_name = "";
      this.title = "";
      this.dob = "";
      this.citizenship = "";
      this.phoneNumber = "";
      this.bussPhoneNumber = "";
      this.address = "";
      this.workPlace = "";
      this.jobTitle = "";
      this.otherJob = "";
      this.countryUniv = "";
      this.UnivName = "";
      this.qualification = "";
      this.major = "";
      this.dateOfCommencement = "";
      this.dateOfCompletion = "";
      this.fundingScheme = "";
      this.scholarName = "";
      this.membertype = "";
      this.memberSector = "";
      this.paymentMethod = "";
      this.paymentRecipt = "";
      this.social = {};
      this.subscription = "";
    },
    handleCreate() {
      this.$Progress.start();
      let formData = new FormData();
      if (this.imageFile) {
        formData.append("profile", this.imageFile);
      }
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("phone_number", this.phoneNumber);
      formData.append("profile", this.imageFile);
      formData.append("dob", this.dob);
      formData.append("gender", this.gender);
      formData.append("email", this.email);
      formData.append("password", this.pass);
      formData.append("subscription_id", this.subscription.id);
      formData.append("payment_id", this.paymentMethod);
      formData.append("attachment_payment_file", this.paymentImageFile);
      formData.append("title", this.title);
      formData.append("business_phone", this.bussPhoneNumber);
      formData.append("business_email", this.bussEmail);
      formData.append("home_address", this.address);
      formData.append("citizenship", this.citizenship);
      formData.append("name_of_organization_workplace", this.workPlace);
      formData.append("job_title", this.jobTitle);
      formData.append("other_job", this.otherJob);
      formData.append("country_of_university_attended", this.countryUniv);
      formData.append("name_of_university_attended", this.UnivName);
      formData.append("highest_qualification", this.qualification);
      formData.append("major", this.major);
      formData.append("date_of_commencement", this.dateOfCommencement);
      formData.append("date_of_completion", this.dateOfCompletion);
      formData.append("funding_scheme", this.fundingScheme);
      formData.append("scholarship_name", this.scholarName);
      formData.append("public_info_to_membership_list", this.publicMember);
      formData.append("membership_category", this.membertype);
      formData.append("membership_sector", this.memberSector);

      const socialsArray = [];
      if (this.social.facebook) {
        socialsArray.push({title: "facebook", url: this.social.facebook});
      }
      if (this.social.linkedin) {
        socialsArray.push({title: "linkedin", url: this.social.linkedin});
      }
      formData.append("social_medias", JSON.stringify(socialsArray));


      userService
          .storeCreateMember(formData)
          .then(() => {
            this.$Progress.finish();
            this.createSideBar = false;
            this.email = "";
            this.bussEmail = "";
            this.memberStatus = "";
            this.imageFile = "";
            this.paymentImageFile = "";
            this.first_name = "";
            this.last_name = "";
            this.title = "";
            this.dob = "";
            this.citizenship = "";
            this.phoneNumber = "";
            this.bussPhoneNumber = "";
            this.address = "";
            this.workPlace = "";
            this.jobTitle = "";
            this.otherJob = "";
            this.countryUniv = "";
            this.UnivName = "";
            this.qualification = "";
            this.major = "";
            this.dateOfCommencement = "";
            this.dateOfCompletion = "";
            this.fundingScheme = "";
            this.scholarName = "";
            this.membertype = "";
            this.memberSector = "";
            this.paymentMethod = "";
            this.paymentRecipt = "";
            this.social = {};
            this.subscription = ""
            this.toast.success("Create new member successful.");
          })
          .catch((error) => {
            this.$Progress.fail();
            console.log(error);
            this.toast.error("Error! Cannot create new member!");
          });
    },
    handleEdit(member) {
      this.createSideBar = !this.createSideBar;
      this.updateFlag = !this.updateFlag;
      this.tempId = member.id;
      // Set the existing profile image URL
      if (member.profile) {
        this.imageUrl = member.profile;
      }
      this.email = member.email;
      if (member.business_email && member.business_email != "null") {
        this.bussEmail = member.business_email;
      }
      this.first_name = member.first_name;
      this.last_name = member.last_name;
      this.title = member.title;
      this.dob = member.dob;
      this.citizenship = member.citizenship;
      this.phoneNumber = member.phone_number;
      if (member.business_phone && member.business_phone != "null") {
        this.bussPhoneNumber = member.business_phone;
      }
      if (member.home_address && member.home_address !== "null") {
        this.address = member.home_address;
      }
      if (member.name_of_organization_workplace && member.name_of_organization_workplace != "null") {
        this.workPlace = member.name_of_organization_workplace;
      }
      if (member.job_title && member.job_title != "null") {
        this.jobTitle = member.job_title;
      }
      if (member.other_job && member.other_job !== "null") {
        this.otherJob = member.other_job;
      }
      if (member.country_of_university_attended && member.name_of_university_attended) {
        this.countryUniv = member.country_of_university_attended;
      }
      if (member.name_of_university_attended && member.name_of_university_attended != "null") {
        this.UnivName = member.name_of_university_attended;
      }
      this.qualification = member.highest_qualification;
      if (member.major && member.major != "null") {
        this.major = member.major;
      }
      this.dateOfCommencement = member.date_of_commencement;
      this.dateOfCompletion = member.date_of_completion;
      if (member.funding_scheme) {
        this.fundingScheme = member.funding_scheme;
      }
      this.scholarName = member.scholarship_name;
      this.membertype = member.membership_category;
      this.memberSector = member.membership_sector;
      if (Array.isArray(member.social_medias)) {
        member.social_medias.forEach(socialObj => {
          if (socialObj.title === "facebook") {
            this.social.facebook = socialObj.url;
          } else if (socialObj.title === "linkedin") {
            this.social.linkedin = socialObj.url;
          }
        });
      }
      this.publicMember = member.public_info_to_membership_list ? 1 : 0;
    },
    handleProfileImport() {
      this.$refs.profileUploader.click();
    },
    handleFileUpload(event) {
      this.imageFile = event.target.files[0];
      this.imageUrl = URL.createObjectURL(this.imageFile);
    },
    handleUpdateMember() {
      this.$Progress.start();
      let formData = new FormData();
      // Only append profile if user uploaded a new image
      if (this.imageFile) {
        formData.append("profile", this.imageFile);
      }
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("phone_number", this.phoneNumber);
      formData.append("dob", this.dob);
      formData.append("gender", this.gender);
      formData.append("email", this.email);
      formData.append("title", this.title);
      formData.append("business_phone", this.bussPhoneNumber);
      formData.append("business_email", this.bussEmail);
      formData.append("home_address", this.address);
      formData.append("citizenship", this.citizenship);
      formData.append("name_of_organization_workplace", this.workPlace);
      formData.append("job_title", this.jobTitle);
      formData.append("other_job", this.otherJob);
      formData.append("country_of_university_attended", this.countryUniv);
      formData.append("name_of_university_attended", this.UnivName);
      formData.append("highest_qualification", this.qualification);
      formData.append("major", this.major);
      formData.append("date_of_commencement", this.dateOfCommencement);
      formData.append("date_of_completion", this.dateOfCompletion);
      formData.append("funding_scheme", this.fundingScheme);
      formData.append("scholarship_name", this.scholarName);
      formData.append("public_info_to_membership_list", this.publicMember);
      formData.append("membership_category", this.membertype);
      formData.append("membership_sector", this.memberSector);

      const socialsArray = [];
      if (this.social.facebook) {
        socialsArray.push({title: "facebook", url: this.social.facebook});
      }
      if (this.social.linkedin) {
        socialsArray.push({title: "linkedin", url: this.social.linkedin});
      }
      formData.append("social_medias", JSON.stringify(socialsArray));

      userService
          .storeUpdateMember(this.tempId, formData)
          .then(() => {
            this.$Progress.finish();
            this.tempId = "";
            this.imageFile = "";
            this.imageUrl = "";
            this.email = "";
            this.bussEmail = "";
            this.memberStatus = "";
            this.imageFile = "";
            this.paymentImageFile = "";
            this.first_name = "";
            this.last_name = "";
            this.title = "";
            this.dob = "";
            this.citizenship = "";
            this.phoneNumber = "";
            this.bussPhoneNumber = "";
            this.address = "";
            this.workPlace = "";
            this.jobTitle = "";
            this.otherJob = "";
            this.countryUniv = "";
            this.UnivName = "";
            this.qualification = "";
            this.major = "";
            this.dateOfCommencement = "";
            this.dateOfCompletion = "";
            this.fundingScheme = "";
            this.scholarName = "";
            this.membertype = "";
            this.memberSector = "";
            this.paymentMethod = "";
            this.paymentRecipt = "";
            this.social = {};
            this.getMember();
            this.createSideBar = false;
            this.updateFlag = false;
            this.toast.success("Update member detail successful.");
          })
          .catch((error) => {
            this.$Progress.fail();
            console.log(error);
            this.errorMsg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            this.toast.error(this.errorMsg);
          });
    },
    handleDelete(id) {
      this.tempId = id;
      this.showConfirmDelete = true;
    },
    handleCloseModal() {
      this.showConfirmDelete = false;
      this.confirmInactive = false;
      this.tempId = "";
      this.year = "";
    },
    handleDeleteUser() {
      this.$Progress.start();
      userService
          .delUser(this.tempId)
          .then(() => {
            this.$Progress.finish();
            this.tempId = "";
            this.showConfirmDelete = false;
            this.getMember();
            this.toast.success("Delete member successful.");
          })
          .catch((error) => {
            this.$Progress.fail();
            console.log(error);
            this.errorMsg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            this.toast.error(this.errorMsg);
          });
    },
    handleUpdateSub(member) {
      this.tempId = member.id;
      this.updateSubFlag = true;
      this.subscription = member.latest_subscription.subscription;
    },
    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("subscription_id", this.subscription.id);
      formData.append("for_year", this.year);
      formData.append("payment_id", this.paymentMethod.id);
      formData.append("attachment_payment_file", this.imageFile);
      formData.append('payment_date', this.paymentDate);
      formData.append("confirm_payment", this.payStatus.value);

      userService.storeUpdateMemberSubscription(this.tempId, formData).then(() => {
        this.$Progress.finish();
        this.getMember();
        this.toast.success("Update member subscription successful.");
        this.tempId = "";
        this.imageFile = "";
        this.imageUrl = "";
        this.subscription = "";
        this.paymentDate = "";
        this.year = new Date().getFullYear();
        this.paymentMethod = "";
        this.payStatus = "";
        this.updateSubFlag = false;
      });
    },
    handleGetMemberCategory() {
      userService.getMemberCategory().then((response) => {
        this.memberTypes = response.data.data;
      });
    },
    handleGetMemberSector() {
      userService.getMemberSector().then((response) => {
        this.memberSectors = response.data.data;
      });
    },
    handleMarkInactive() {
      this.markInactiveSideBar = true;
      this.year = new Date().getFullYear() - 1;
    },
    handleCloseMarkInactive() {
      this.markInactiveSideBar = false;
      this.year = new Date().getFullYear() - 1;
    },
    handleShowConfirmInactive() {
      this.markInactiveSideBar = false;
      this.confirmInactive = true;
    },
    handleMarkInactiveUser() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("for_year", this.year);
      userService
          .storeMarkInactiveMember(formData)
          .then(() => {
            this.$Progress.finish();
            this.toast.success("Mark inactive member successful.");
            this.year = new Date().getFullYear() - 1;
            this.confirmInactive = false;
            this.getMember();
          })
          .catch((error) => {
            this.$Progress.fail();
            console.log(error);
            this.errorMsg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            this.toast.error(this.errorMsg);
          });
    },
    handleshowSendMessage() {
      this.showSendRemindMsg = true;
    },
    handleCloseSendRemindMsg() {
      this.showSendRemindMsg = false;
      this.msgTitle = "";
      this.content = "";
    },
    handleSendMessage() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title", this.msgTitle);
      formData.append("message", this.content);
      formData.append("year_of_subscription", this.year);
      userService
          .sendRemindMessage(formData)
          .then(() => {
            this.$Progress.finish();
            this.toast.success("Send remind message successful.");
            this.showSendRemindMsg = false;
            this.msgTitle = "";
            this.content = "";
          })
          .catch((error) => {
            this.$Progress.fail();
            console.log(error);
            this.errorMsg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            this.toast.error(this.errorMsg);
          });
    },
  },
  computed: {
    isFirstNameValid() {
      return !!this.first_name;
    },
    isLastNameValid() {
      return !!this.last_name;
    },
    isPhoneNumberValid() {
      return !!this.phoneNumber;
    },
    isEmailValid() {
      return !!this.email;
    },
    isJobTitleValid() {
      return !!this.jobTitle;
    },
    isPasswordValid() {
      return !!this.pass;
    },
    isMemberCategoryValid() {
      return !!this.membertype;
    },
    isMemberSectorValid() {
      return !!this.memberSector;
    },
    isSubscriptionValid() {
      return !!this.subscription;
    },
    isUpdateValid() {
      return (
          this.isFirstNameValid &&
          this.isLastNameValid &&
          this.isEmailValid &&
          this.isPhoneNumberValid &&
          this.isJobTitleValid
      );
    },
    isCreateMemberValid() {
      return (
          this.isFirstNameValid &&
          this.isLastNameValid &&
          this.isEmailValid &&
          this.isPhoneNumberValid &&
          this.isJobTitleValid &&
          this.isMemberCategoryValid &&
          this.isMemberSectorValid &&
          this.isSubscriptionValid &&
          this.isPasswordValid
      );
    },
  },
  created() {
    this.$Progress.start();
    this.moment = moment;
    this.getSubscriptionList();
    this.getPaymentMethod();
    this.handleGetMemberCategory();
    this.handleGetMemberSector();
    if (this.$route.query.subscription_id) {
      this.params.set("subscription_id", this.$route.query.subscription_id);
    } else if (this.$route.query.status_id) {
      this.params.set("status", this.$route.query.status_id);
    }

    if (this.$route.query.status_id == 2) {
      this.statusFilter = {key: "2", name: "Active"};
    } else if (this.$route.query.status_id == 0) {
      this.statusFilter = {key: "0", name: "Inactive"};
    }

    if (this.$route.query.is_paid == 1) {
      this.isPaidFilter = {
        name: "Paid",
        value: "1",
      };
      this.params.set("is_paid", this.$route.query.is_paid);
      this.paymentStatusFilter = {key: "1", name: "Accept"};
    } else if (this.$route.query.is_paid == 0) {
      this.isPaidFilter = {
        name: "Unpaid",
        value: "0",
      };
      this.params.set("is_paid", this.$route.query.is_paid);
      this.paymentStatusFilter = {key: "0", name: "Pending"};
    }

    // apply filter here
    this.getMember(
        this.params.toString()
    );
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.square_img {
  aspect-ratio: 1/1;
}

.rect_img {
  aspect-ratio: 16/9;
}
</style>
